import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtCurrency, fmtDate } from "../../lib/api";
import MobileHeader from "../../components/MobileHeader";
import { Button } from "../../components/ui/button";

const PRODUCTS = [
    { name: "SplitPay", title: "SplitPay™", subtitle: "Group + bulk-credit orders", color: "#A855F7", badge: "NEW" },
    { name: "BizCredit", title: "BizCredit™", subtitle: "Working capital", color: "#0066FF" },
    { name: "TradeCredit", title: "TradeCredit™", subtitle: "Invoice financing", color: "#06B6D4" },
    { name: "StockFinance", title: "StockFinance™", subtitle: "Inventory-backed", color: "#FF6B00" },
    { name: "AgroCredit", title: "AgroCredit™", subtitle: "Agriculture lending", color: "#00D084" },
    { name: "FleetFinance", title: "FleetFinance™", subtitle: "Logistics & transport", color: "#7000FF" },
];

export default function BusinessLoans() {
    const [loans, setLoans] = useState([]);

    useEffect(() => { api.get("/loans").then((r) => setLoans(r.data)); }, []);

    const active = loans.filter((l) => l.status === "active" || l.status === "disbursed");

    return (
        <div data-testid="business-loans-page">
            <MobileHeader title="Loans" backTo="/business" variant="blue" />
            <div className="px-5 -mt-6 pb-4 space-y-4">
                <div>
                    <div className="flex items-center justify-between mb-3">
                        <h2 className="font-display font-semibold text-[#0A1930]">Available Offers</h2>
                        <span className="text-xs font-semibold text-[#0066FF]">See All</span>
                    </div>
                    {/* Featured offer */}
                    <Link to="/business/loans/BizCredit" className="block" data-testid="featured-bizcredit">
                        <div className="rounded-2xl gradient-business gradient-noise p-5 text-white relative overflow-hidden">
                            <div className="text-xs uppercase tracking-wider text-white/80">BizCredit™</div>
                            <div className="font-display text-xl font-semibold mt-1">Up to ₦5,000,000</div>
                            <div className="text-xs text-white/80 mt-1">Working capital for your business</div>
                            <div className="mt-4 inline-block bg-white/15 backdrop-blur rounded-lg px-4 py-2 text-xs font-bold">View Offer</div>
                        </div>
                    </Link>
                </div>

                {/* Active loans */}
                <div>
                    <h2 className="font-display font-semibold text-[#0A1930] mb-3">Active Loans</h2>
                    {active.length === 0 && <div className="bg-white rounded-2xl border border-slate-200 p-6 text-center text-sm text-slate-500">No active business loans</div>}
                    <div className="space-y-2">
                        {active.map((l) => (
                            <Link to={`/business/loans/detail/${l.id}`} key={l.id} data-testid={`active-loan-${l.id}`} className="block bg-white rounded-2xl border border-slate-200 p-4 product-shadow">
                                <div className="flex justify-between items-start">
                                    <div>
                                        <div className="font-display font-semibold text-[#0A1930]">{l.product}™</div>
                                        <div className="text-xs text-slate-500">Due {fmtDate(l.due_date)}</div>
                                    </div>
                                    <div className="font-display text-lg font-bold">{fmtCurrency(l.amount)}</div>
                                </div>
                                <div className="mt-3 h-1.5 bg-slate-100 rounded-full overflow-hidden">
                                    <div className="h-full bg-[#0066FF]" style={{ width: `${Math.min(100, ((l.repaid_amount || 0) / l.total_repayment) * 100)}%` }} />
                                </div>
                                <div className="flex justify-between text-[11px] text-slate-500 mt-1">
                                    <span>Remaining {fmtCurrency(l.total_repayment - (l.repaid_amount || 0))}</span>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>

                {/* All products */}
                <div>
                    <h2 className="font-display font-semibold text-[#0A1930] mb-3">Explore products</h2>
                    <div className="grid grid-cols-2 gap-3">
                        {PRODUCTS.map((p) => (
                            <Link to={`/business/loans/${p.name}`} key={p.name} data-testid={`biz-loan-${p.name}`} className="bg-white rounded-2xl border border-slate-200 p-4 tap-feedback">
                                <div className="size-10 rounded-xl flex items-center justify-center font-display font-bold text-white" style={{ background: p.color }}>
                                    {p.title.slice(0, 1)}
                                </div>
                                <div className="font-display font-semibold text-sm mt-2" style={{ color: p.color }}>{p.title}</div>
                                <div className="text-[11px] text-slate-500">{p.subtitle}</div>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
